<ion-item>
  <ion-checkbox [name]="id" (ionChange)="select($event)" [checked]="item.checked">{{ label }}</ion-checkbox>
</ion-item>
